import axiosClient from '../../../config/axios-client'

const OpportunityService = {
  getCountries() {
    return axiosClient.get(`/dashboard/countries/opportunities`)
  },
  getCountry(countryId) {
    return axiosClient.get(`/dashboard/countries/${countryId}`)
  },
  getOpportunities(countryId) {
    return axiosClient.get(`/dashboard/countries/${countryId}/opportunities`)
  },
  createCountryOpportunity(countryId, payload) {
    return axiosClient.post(
      `/dashboard/countries/${countryId}/opportunities`,
      payload,
    )
  },
  getCountryOpportunitySource(countryId) {
    return axiosClient.get(`/dashboard/countries/${countryId}/source`)
  },
  updateCountryOpportunitySource(countryId, payload) {
    return axiosClient.post(`/dashboard/countries/${countryId}/source`, payload)
  },
  getOpportunity(countryId, opportunityId) {
    return axiosClient.get(
      `/dashboard/countries/${countryId}/opportunities/${opportunityId}`,
    )
  },
  updateCountryOpportunity(countryId, opportunityId, payload) {
    return axiosClient.post(
      `/dashboard/countries/${countryId}/opportunities/${opportunityId}`,
      payload,
    )
  },
  deleteCountryOpportunity(countryId, opportunityId) {
    return axiosClient.delete(
      `/dashboard/countries/${countryId}/opportunities/${opportunityId}`,
    )
  },
}

export default OpportunityService
